// orders
export const selectVendorOrders = (state) => state.order.vendorOrders;
export const selectAllOrders = (state) => state.order.allOrders;
export const selectReturnOrders = (state) => state.order.returnOrders; 
export const selectVendorLoading = (state) => state.order.loading;
export const selectReturnLoading = (state) => state.order.returnLoading; 
export const selectVendorError = (state) => state.order.error;
export const selectVendorSuccess = (state) => state.order.success;
export const selectUpdating = (state) => state.order.updating;
export const selectReturnUpdating = (state) => state.order.returnUpdating;

// payments
export const selectPaymentDetails = (state) => state.order.paymentDetails;
export const selectPaymentsLoading = (state) => state.order.loading;
export const selectPaymentsError = (state) => state.order.error;
export const selectPaymentsSuccess = (state) => state.order.success;


export const selectPaymentDetailsByAdmin = (state) => state.order.paymentDetailsByAdmin;
export const selectPaymentsLoadingByAdmin = (state) => state.order.loading;
export const selectPaymentsErrorByAdmin = (state) => state.order.error;
